import Form from './Form.js';
import 'bootstrap/js/dist/collapse';
import Masonry from 'masonry-layout';
import lottie from 'lottie-web';
import 'slick-carousel';


const common = (($) => {
	'use strict';

	
	/**
	 * Some function
	*
	* @since   1.0.0
	*/
	const someFunction = () => {
		console.log('Ready');
	};

	/**
	 * Check top
	 *
	 * @since   1.0.0
	 */
	const checkTop = () => {
		$(document).on( 'scroll', function() {
			if($(window).scrollTop() >= 70) {
				$("body").addClass("not-top");
			}else{
				$("body").removeClass("not-top");
			}
		});
	};

	/**
	 * Select
	 *
	 * @since   1.0.0
	 */
	const selectInit = () => {
		var eventSelect = $('select.js-select');
		eventSelect.select2({
			minimumResultsForSearch: -1,
			dropdownAutoWidth: true,
			width: '100%',
		});
	};

	 /**
     * Slick slider
     *
     * @since   1.0.0
     */
	 const slickInit = () => {
        $('.js-gallery-slider').slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 0,
            pauseOnHover: false,
            fade: true,
            responsive: [
                {
                    breakpoint: 1198,
                    settings: {
                        arrows: true,
                    }
                },
            ],
        });
    };

	/**
	 * Select
	 *
	 * @since   1.0.0
	 */
	const fancyboxInit = () => {
		$('[data-fancybox]').fancybox({
			thumbs : {
				autoStart : true,
				axis : 'x'
			}
		});
	};

	/**
	 * Lottie animations
	 *
	 * @since   1.0.0
	 */
	const lottieInit = () => {
		let animation = lottie.loadAnimation({
			container: document.getElementById('path'), // the dom element that will contain the animation
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: php_vars.theme_uri + '/assets/json/data.json' // the path to the animation json
		});

		let play = true;

		$(window).on('resize scroll', function() {
			if ( $('#path').length ) {
				if ($('#path').isInViewport()) {
					if (play) {
						animation.play();
						$('.steps').addClass('animate');
					}
					play = false;
				}
			}
		});

		$.fn.isInViewport = function() {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
		
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
		
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};
	};

	/**
	 * Date field init
	 *
	 * @since   1.0.0
	 */
	const dateInit = () => {
		$( ".js-date" ).each(function( i ) {
			new Litepicker({
				element: document.getElementsByClassName('js-date')[i],
				singleMode: true,
				inlineMode: false,
				lang: "lv-LV",
				weekday: "short",
				format: document.getElementsByClassName('js-date')[i].getAttribute('format'),
				splitView: false,
				showTooltip: false,
				numberOfColumns: 1,
				numberOfMonths: 1,
			});
		});
	};

	/**
	 * Phone field
	 *
	 * @since   1.0.0
	 */
	 const phoneInit = () => {
		var errorMap = JSON.parse(php_vars.error_msg);
		
		$.extend($.validator.messages, {
			required: errorMap.required,
			email: errorMap.email,
			remote: errorMap.remote,
			url: errorMap.url,
			date: errorMap.date,
			dateISO: errorMap.dateISO,
			number: errorMap.number,
			digits: errorMap.digits,
			creditcard: errorMap.creditcard,
			equalTo: errorMap.equalTo,
			accept: errorMap.accept,
			maxlength: $.validator.format(errorMap.maxlength),
			minlength: $.validator.format(errorMap.minlength),
			rangelength: $.validator.format(errorMap.rangelength),
			range: $.validator.format(errorMap.range),
			max: $.validator.format(errorMap.max),
			min: $.validator.format(errorMap.min)
		});
	};

	/**
	 * Form functions and validation
	 *
	 * @since   1.0.0
	 */
	const formFunctions = () => {
		var formElement = [
			"form.contact-form",
		];
		var dropzoneElement = "div.js-drag-n-drop";
		formElement.forEach(function(thisElement){
			if ( $(thisElement).length ) {            
				// Form validation
				$(thisElement).validate({
					invalidHandler: function(event, validator) {
						var errors = validator.numberOfInvalids();
						$(thisElement).find('.success-message').hide();
						if (errors) {
							$(thisElement).find(".error-message").show();
						} else {
							$(thisElement).find(".error-message").hide();
						}
					},
					submitHandler: function(form) {
						$(form).find('.js-submit').addClass('disabled').addClass('loading');
						$(thisElement).find('.error-message').hide();
						submitForm(thisElement);
					}
				});
				
				// Error messages
				var errorMap = JSON.parse(php_vars.error_msg);
				
				// Phone field validation
				var input = document.querySelector(".js-phone");
				if (input) {			
					var iti = window.intlTelInput(input, {
						utilsScript: php_vars.theme_uri + '/assets/src/js/intl-tel-input/utils.js',
						preferredCountries: ["lv"],
					});
					$.validator.addMethod( "tel", function(value, element) {
						if (! iti.isValidNumber()) {
							return this.optional(element) || false;
						} else {
							return this.optional(element) || true;
						}
					}, function(value, element) {
						var errorCode = iti.getValidationError();
						if (errorMap.tel[errorCode] !== undefined) {
							return errorMap.tel[errorCode];
						}else {
							return errorMap.tel[0];
						}
					});
				}
				
				// Form date validation
				$.validator.addMethod( "formatDate", function(value, element) {
					var dateReg = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
					return this.optional(element) || value.match(dateReg);
				},
				errorMap.date
				);
				
				$.validator.addClassRules({
					'js-date': {
						formatDate: true,
					}
				});	
			}				
		});
		// Form submit action
		$('.js-submit').on('click', (event) => {
			event.preventDefault();
			var form = $(event.currentTarget).closest('form');
			console.log(form);
			form.trigger('submit');
		});

		// Form ajax
		function submitForm(formElement, action) {
			var Form_1 = new Form(formElement);
			Form_1.Data['action'] = $(formElement).attr('action');
			//if ( myDropzone.files.length > 0 ) Form_1.Data['attachments'] = JSON.stringify(myDropzone.files);
			
			Form_1.post(php_vars.ajax_url, (response) => {
				$(formElement).find('.js-submit').removeClass('disabled').removeClass('loading');
				
				if(response == '000'){
					$(formElement).find('.success-message').show();
					$(formElement).find('.input').val('');
					$(formElement).find('.js-select').val('').change();
					$(formElement).find('[type="checkbox"]').prop( "checked", false );
					//myDropzone.removeAllFiles(true);
				}else{
					console.log(response);
					$(formElement).find('.error-message').show();
				}
			});
		}
	};
	
	/**
	 * Offer functions
	 *
	 * @since   1.0.0
	 */
	const offerFunctions = () => {
		$('.js-to-offer-form').on('click',function(e) {
			e.preventDefault();
			const value = $(this).data('offer');
			$('[name="contact_form[offer]"]').val(value).trigger('change');
			$([document.documentElement]).animate({
				scrollTop: $('.contact-form').offset().top - 80
			}, 0);
		})
	};

	/**
	 * Offer functions
	 *
	 * @since   1.0.0
	 */
	const mobileMenu = () => {
		$('.navbar-toggler').on('click', function() {
			if ($('#burger').is(":checked")) {
				$('body').addClass('menu-open');
			}else{
				$('body').removeClass('menu-open');
			}
		});

		$('.featured-link a').on('click', function() {
			if ($('#burger').is(":checked")) {
				$( "#burger" ).prop( "checked", false );
				$('body').removeClass('menu-open');
			}
		});
	};


	/**
	 * Scrolling
	 *
	 * @since   1.0.0
	 */
	const scrolling = () => {
		$('a[href*=\\#]').on('click', function (event) {
			if(this.pathname === window.location.pathname){
				scrollToAnchor($(this).attr('href'));
			}
		});
	};

	/**
	 * Fire events on document ready and bind other events
	 *
	 * @since   1.0.0
	 */
	const ready = () => {
		someFunction();
		checkTop();
		fancyboxInit();
		lottieInit();
		offerFunctions();
		mobileMenu();
		slickInit();
		//scrolling();

		// Form
		selectInit();
		phoneInit();
		dateInit();
		formFunctions();
	};

	/**
	 * Only expose the ready function to the world
	 */
	return {
		ready: ready
	}


	//Scroll to anchor
	function scrollToAnchor(aid){
		if ($(window).width() < 768) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(aid).offset().top - 80
			}, 0);
		}else{
			$([document.documentElement, document.body]).animate({
				scrollTop: $(aid).offset().top - 200
			}, 0);
		}
	}

})(jQuery);

jQuery(common.ready);
